<template>
  <v-dialog :model-value="DialogAuditLogs">
    <v-card rounded="lg">
      <v-toolbar class="toolbar-color">
        <v-toolbar-title class="text-white">
          <v-icon color="white" class="mr-2">mdi-file-edit</v-icon>
          Audit Logs
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          v-model="fromMenu"
          :close-on-content-click="false"
          min-width="auto"
          transition="scale-transition"
        >
          <template v-slot:activator="{ props }">
            <v-text-field
              prepend-inner-icon="mdi-calendar"
              variant="outlined"
              density="compact"
              label="From Date"
              max-width="150"
              class="mt-6 mr-2 field-color text-white"
              v-bind="props"
              :model-value="formatedFromDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="from_date"
            class="datepicker-color text-white"
          ></v-date-picker>
        </v-menu>

        <v-menu
          v-model="toMenu"
          transition="scale-transition"
          :close-on-content-click="false"
          man-width="auto"
        >
          <template v-slot:activator="{ props }">
            <v-text-field
              prepend-inner-icon="mdi-calendar"
              icon="mdi-calendar"
              variant="outlined"
              density="compact"
              label="To Date"
              max-width="150"
              class="mt-6 mr-2 field-color text-white"
              v-bind="props"
              :model-value="formatedToDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="to_date"
            class="datepicker-color text-white"
          ></v-date-picker>
        </v-menu>
        <v-select
          v-model="selected_app_filter"
          variant="outlined"
          density="compact"
          label="Filter by app"
          max-width="180"
          class="mt-6 mr-2 field-color text-white"
          :items="appitems"
          item-title="title"
          item-value="value"
        ></v-select>
        <v-select
          v-model="selected_source_status"
          variant="outlined"
          density="compact"
          label="Filter by app"
          max-width="110"
          class="mt-6 field-color text-white"
          :items="sourceitems"
          item-title="title"
          item-value="value"
        ></v-select>
        <v-btn icon elevation="0" @click="fetchAuditLogsMethod()">
          <v-icon color="white">mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon elevation="0" @click="DialogAuditLogsEmit(1)">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="TableHeaders"
        :height="CommonVuetifyObj.height - 245"
        :items="ListAllAuditLogs"
        :items-per-page="itemsPerPage"
        :page="page"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [10],
        }"
        class="modern-data-table"
        hide-default-footer
        fixed-header
        no-data-text="Click search for data!"
      >
        <template v-slot:[`item.action_time`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-clock-outline</v-icon>
            <div class="ml-2">{{ ConvertDate(item.action_time * 1000) }}</div>
          </div>
        </template>

        <template v-slot:[`item.app`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-auto-mode</v-icon>
            <div class="ml-2">{{ item.app }}</div>
          </div>
        </template>

        <template v-slot:[`item.action_from`]="{ item }">
          <div class="d-flex align-center">
            <v-icon
              v-if="item.action_from === 'PHONE'"
              class="icon-color"
              size="small"
              >mdi-cellphone</v-icon
            >
            <v-icon v-else class="icon-color" size="small">mdi-web</v-icon>
            <div class="ml-2">{{ item.action_from }}</div>
          </div>
        </template>

        <template v-slot:[`item.user_name`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-account</v-icon>
            <div class="ml-2">{{ item.user_name }}</div>
          </div>
        </template>

        <template v-slot:[`item.description`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-chat</v-icon>
            <div class="ml-2">{{ item.description }}</div>
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="v-pagination__item"
        density="compact"
        :length="pageCount"
        :total-visible="1"
      ></v-pagination>
    </v-card>
  </v-dialog>
</template>

<script>
import { useDisplay } from "vuetify/lib/framework.mjs";
import { GetAllListAuditLogs } from "@/mixins/Teams/GetAllListAuditLogs";

export default {
  props: { DialogAuditLogs: Boolean, organizationId: String },

  mixins: [GetAllListAuditLogs],

  data: () => ({
    from_date: "",
    to_date: "",

    page: 1,
    previous_page: 0,
    itemsPerPage: 10,

    fromMenu: false,
    toMenu: false,
    loading: false,

    selected_app_filter: "ALL",
    selected_source_status: "ALL",

    CommonVuetifyObj: {},

    ListAllAuditLogs: [],
    sourceitems: [
      { title: "All", value: "ALL" },
      { title: "Web", value: "WEB" },
      { title: "Phone", value: "PHONE" },
    ],
    appitems: [
      { title: "All", value: "ALL" },
      { title: "Workflow", value: "WORKFLOW" },
      { title: "Form", value: "FORM" },
      { title: "Slot Booking", value: "SLOT_BOOKING" },
      { title: "Task", value: "TASK" },
      { title: "Channel", value: "CHANNEL" },
      { title: "Directory", value: "DIRECTORY" },
      { title: "TimeSheet", value: "TIMESHEET" },
      { title: "Dashboard", value: "DASHBOARD" },
      { title: "Ticket Management", value: "TICKET_MANAGEMENT" },
      { title: "Stichh", value: "STICHH" },
      { title: "Expense", value: "EXPENSE" },
      { title: "Events", value: "EVENTS" },
      { title: "Presence", value: "PRESENCE" },
    ],
    TableHeaders: [
      { title: "Action Date", value: "action_time", width: "20%" },
      { title: "App", value: "app", width: "20%" },
      { title: "Source", value: "action_from", width: "15%" },
      { title: "Action Taken By", value: "user_name", width: "15%" },
      { title: "Action Message", value: "description", width: "25%" },
    ],
  }),
  watch: {
    async page(val) {
      if (val > this.previous_page) {
        this.loading = true;
        await this.GetAllListAuditLogsMethod(this.organizationId);
        this.loading = false;
      }
      if (val > this.previous_page) {
        this.loading = true;
        this.previous_page = val;
        this.loading = false;
      }
    },
    async DialogAuditLogs(val) {
      if (val == true) {
        this.loading = true;
        await this.GetAllListAuditLogsMethod(this.organizationId);
        this.loading = false;
      }
    },
  },
  computed: {
    formatedFromDate() {
      if (!this.from_date) return "";
      return this.ConvertedFromDate(this.from_date);
    },
    formatedToDate() {
      if (!this.to_date) return "";
      return this.ConvertedFromDate(this.to_date);
    },
    pageCount() {
      if (this.ListAllAuditLogs.length == 0) return 1;
      return Math.ceil(this.ListAllAuditLogs.length / this.itemsPerPage);
    },
  },
  async mounted() {
    this.CommonVuetifyObj = useDisplay();
    this.from_date = new Date();
    this.to_date = new Date();
  },
  methods: {
    DialogAuditLogsEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
    async fetchAuditLogsMethod() {
      this.loading = true;
      await this.GetAllListAuditLogsMethod(this.organizationId);
      this.loading = false;
    },
    ConvertedFromDate(from_date) {
      const date = new Date(from_date);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    ConvertedToDate(to_date) {
      const date = new Date(to_date);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    ConvertDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style>
.toolbar-color {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
}
.datepicker-color {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
}
.field-color .v-field--variant-outlined {
  --v-border-color: white !important;
}
.icon-color {
  background: linear-gradient(135deg, #1967c0 0%, #0f3d73 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.v-pagination__item--is-active {
  background: linear-gradient(135deg, #1967c0 0%, #0f3d73 100%) !important;
  color: white !important;
  border-radius: 4px !important;
}
</style>
